module.exports = __webpack_public_path__ + "static/media/price.ca049640.png";